export const PostStatus = {
	PUBLISHED: "published",
	DRAFT: "draft",
	SCHEDULED: "scheduled",
} as const;
export type PostStatus = (typeof PostStatus)[keyof typeof PostStatus];

export const PostMediaType = {
	IMAGE: "image",
	VIDEO: "video",
	FILE: "file",
} as const;
export type PostMediaType = (typeof PostMediaType)[keyof typeof PostMediaType];

export const FeedSortOrder = {
	LATEST: "latest",
	OLDEST: "oldest",
	POPULAR: "popular",
	MOST_LIKED: "most_liked",
} as const;
export type FeedSortOrder = (typeof FeedSortOrder)[keyof typeof FeedSortOrder];

export const SkillType = {
	SKILL: "skill",
	INTEREST: "interest",
} as const;
export type SkillType = (typeof SkillType)[keyof typeof SkillType];

export const FeedContentType = {
	ALL: "all",
	VIDEOS: "videos",
	FILES: "files",
	POLLS: "polls",
	EVENTS: "events",
} as const;
export type FeedContentType = (typeof FeedContentType)[keyof typeof FeedContentType];

export const PostType = {
	TEXT: "text",
	EVENT: "event",
} as const;
export type PostType = (typeof PostType)[keyof typeof PostType];

export const ActivePresenceMode = {
	LIVE: "live",
	FALLBACK: "fallback",
} as const;
export type ActivePresenceMode = (typeof ActivePresenceMode)[keyof typeof ActivePresenceMode];
